var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcChargerHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.531,
    height: 8.971,
    viewBox: "0 0 9.531 8.971",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(-1352.348 -1104.693)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M1360.986,1105.44a.343.343,0,0,1,.3.374v6.729a.343.343,0,0,1-.3.374h-7.745a.343.343,0,0,1-.3-.374v-6.729a.343.343,0,0,1,.3-.374Zm-7.745-.747a1.027,1.027,0,0,0-.893,1.121v6.729a1.027,1.027,0,0,0,.893,1.121h7.745a1.027,1.027,0,0,0,.893-1.121v-6.729a1.027,1.027,0,0,0-.893-1.121Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M1354.135,1107.689a.3.3,0,0,1,.3-.3h5.361a.3.3,0,1,1,0,.6h-5.361A.3.3,0,0,1,1354.135,1107.689Zm0,1.489a.3.3,0,0,1,.3-.3h5.361a.3.3,0,1,1,0,.595h-5.361A.3.3,0,0,1,1354.135,1109.178Zm0,1.49a.3.3,0,0,1,.3-.3h3.574a.3.3,0,1,1,0,.6h-3.574A.3.3,0,0,1,1354.135,1110.668Z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChargerHistory);
export default __webpack_public_path__ + "static/media/ic-charger-history.cad5ad939db780b6cd3bff1409f57e57.svg";
export { ForwardRef as ReactComponent };